import { buildApiUrl, buildAssetUrl } from '../../utils/api';

const normalizeProductDetail = (data) => {
  // gallery_images are usually objects: { product_image_id, image_path, position }.
  const galleryPaths = [...(data.gallery_images || [])]
    .sort((a, b) => (a.position ?? 99) - (b.position ?? 99))
    .map((image) => (
      typeof image === 'string'
        ? image
        : image.image_path || image.image || image.url || image.path
    ));

  const allImagePaths = [
    data.image,
    data.product_image,
    data.image1,
    data.image2,
    data.image3,
    data.image4,
    data.image5,
    data.image6,
    ...galleryPaths,
  ].filter(Boolean);

  const images = [...new Set(allImagePaths)].map(buildAssetUrl);

  return {
    ...data,
    gst: Number.parseFloat(data.gst ?? data.gst_percentage ?? 0) || 0,
    image: images[0] || null,
    images,
    variants: (data.variants || []).map((v) => ({
      ...v,
      discount_price: parseFloat(v.discount_price),
      original_price: parseFloat(v.original_price),
    })),
  };
};

export const createProductDetailSlice = (set) => ({
  productDetail: null,
  productDetail_loading: false,
  productDetail_error: null,

  fetchProductDetail: async (productId) => {
    set({ productDetail_loading: true, productDetail_error: null, productDetail: null });
    try {
      const res = await fetch(buildApiUrl(`/api/v1/customer/product-details/${productId}`));
      if (!res.ok) throw new Error('Failed to fetch product details');
      const json = await res.json();
      if (!json.success) throw new Error(json.message || 'Failed to fetch product details');
      set({ productDetail: normalizeProductDetail(json.data), productDetail_loading: false });
    } catch (err) {
      set({ productDetail_error: err.message, productDetail_loading: false });
    }
  },

  clearProductDetail: () => set({ productDetail: null, productDetail_error: null }), 
});
 
